'use strict';

var SELECTOR       = '[data-toggle]';
var ACTIVE_CLASS   = 'toggle-active';
var NAV_OPEN_CLASS = 'nav-open';

var $body = $(document.body);

/**
 * Constructor.
 *
 * @param  {DOMElement|string}  element
 * @param  {object}             options
 */
var Toggler = function (element, options)
{
    //
};

Toggler.VERSION = '0.1.0';

Toggler.$backdrop = $(document.createElement('DIV'))
    .addClass('toggle-backdrop')
    .appendTo($body);

/**
 * Initiate the toggle (on/off).
 *
 * @param  {object}  e
 */
Toggler.prototype.toggle = function (e)
{

    var $this    = $(this);
    var $parent  = $this.parent();
    var type     = $this.data('toggle');
    var isActive = $parent.hasClass(ACTIVE_CLASS);

    Toggler.prototype.clearToggled(e);

    // Already active?
    if (isActive) {
        // If we're clicking on a sub-menu item that's already active,
        // return true so we can follow the link.
        return type === 'sub-menu';
    }

    // If a target is set, also add the active class to it.
    if ($this.data('target')) {
        $($this.data('target')).toggleClass(ACTIVE_CLASS);
    }

    $parent.toggleClass(ACTIVE_CLASS);

    return false;
}

/**
 * Toggles the parent toggle container.
 *
 * @param  {object}  e
 */
Toggler.prototype.closeParent = function (e)
{
    $(this).closest('.' + ACTIVE_CLASS)
        .removeClass(ACTIVE_CLASS);

    return false;
}

/**
 * Deactivate all active toggles.
 *
 * @param  {object}  e
 */
Toggler.prototype.clearToggled = function (e)
{

    $(SELECTOR).each(function () {

        var $this    = $(this);
        var $parent  = $this.parent();
        var type     = $this.data('toggle');
        var isActive = $parent.hasClass(ACTIVE_CLASS);

        // Return if the parent element isn't currently active.
        if ( ! isActive) {
            return;
        }

        // If the parent element of the toggle container contains the
        // event target, ignore all future actions as we don't want to
        // deactivate the toggle for it.
        if ($.contains($parent[0], e.target) && e.target !== this && ! $.contains(this, e.target)) {
            return;
        }

        // If a target is set, remove the active class from it.
        if ($this.data('target')) {
            $($this.data('target')).removeClass(ACTIVE_CLASS);
        }

        $parent.removeClass(ACTIVE_CLASS);


    });

}


// TOGGLE PLUGIN DEFINITION
// ==========================

function Plugin (option)
{
    return this.each(function () {
        var $this = $(this);
        var data  = $this.data('hogo.toggle');

        if ( ! data) $this.data('hogo.toggle', (data = new Toggler(this)));
        if (typeof option === 'string') data[option].call($this);
    });
}

$.fn.toggler             = Plugin;
$.fn.toggler.Constructor = Toggler;


// BIND EVENTS
// ===========

$(document)
    .on('click.hogo.toggle', '.toggle-close', Toggler.prototype.closeParent)
    .on('click.hogo.toggle', Toggler.prototype.clearToggled)
    .on('click.hogo.toggle', SELECTOR, Toggler.prototype.toggle);


// EXPORT MODULE
// =============

export default Toggler;